import { jsx, jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import HelperText from "./components/HelperText.js";
import Info from "./components/Info.js";
import Label from "./components/Label.js";
const FormFieldDecoration = ({ hidden, full, containerClassName, hideLabel, label, tooltip, size, state, subLabelElement, info, helperText, childrenId, children })=>{
    const hasError = 'error' === state;
    return /*#__PURE__*/ jsxs("div", {
        hidden: hidden,
        className: clsx(full ? 'tw-w-full' : 'tw-w-28', 'tw-gap-0.8  tw-flex-col', !hidden && 'tw-flex', containerClassName),
        children: [
            !hideLabel && /*#__PURE__*/ jsx(Label, {
                label: label,
                tooltip: tooltip,
                size: size,
                state: state
            }),
            subLabelElement,
            info && /*#__PURE__*/ jsx(Info, {
                info: info,
                inputState: state
            }),
            children,
            helperText && /*#__PURE__*/ jsx(HelperText, {
                text: helperText,
                inputId: childrenId,
                hasError: hasError
            })
        ]
    });
};
const FormFieldDecoration_FormFieldDecoration = FormFieldDecoration;
export default FormFieldDecoration_FormFieldDecoration;
